// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"780":"c669e12b","998":"e7895301"}[chunkId] + ".chunk.js";
};